import type { StoreApi } from 'zustand';

import {
  completeOnboarding,
  nextStep,
  previousStep,
  resetOnboarding,
  setCurrentStep,
  setLoading,
  setOnboardingComplete,
} from './actions';
import { OnboardingStore } from './types';

export const createOnboardingHandlers = (
  setState: StoreApi<OnboardingStore>['setState'],
) => ({
  setOnboardingComplete: (isComplete: boolean) =>
    setState((state) => setOnboardingComplete(state, isComplete)),

  setCurrentStep: (step: number) =>
    setState((state) => setCurrentStep(state, step)),

  setLoading: (isLoading: boolean) =>
    setState((state) => setLoading(state, isLoading)),

  nextStep: () => setState((state) => nextStep(state)),

  previousStep: () => setState((state) => previousStep(state)),

  completeOnboarding: () => setState((state) => completeOnboarding(state)),

  resetOnboarding: () => setState((state) => resetOnboarding(state)),
});
